export default __webpack_public_path__ + "static/media/thinkai.139862d2.jpg";